import { defineStore } from "pinia";
import useApiFetch from "../composables/useApi";
import { Ref, ref } from "vue";
import router from "../router";
import axios from "axios";

export const useAppStore = defineStore("appStore", () => {
  const showDepositModal = () => {
    hideBotModal();
    document.getElementById("depositModal")?.classList.remove("hidden");
  };

  const hideDepositModal = () => {
    document.getElementById("depositModal")?.classList.add("hidden");
  };

  const hidePrimezordModal = () => {
    document.getElementById("primezordModal")?.classList.add("hidden");
  };

  const showBotModal = () => {
    hideDepositModal();
    document.getElementById("botModal")?.classList.remove("hidden");
  };

  const showCopyModal = () => {
    hideDepositModal();
    document.getElementById("copyModal")?.classList.remove("hidden");
  };

  const hideCopyModal = () => {
    document.getElementById("copyModal")?.classList.add("hidden");
  };

  const hideBotModal = () => {
    document.getElementById("botModal")?.classList.add("hidden");
  };

  const hideWithdrawModal = () => {
    withdrawModal.value = false;
  };

  const balance = ref(0);

  const finished_stakes = ref(0);
  const running_stakes = ref(0);
  const total_commissions = ref(0);
  const amount_staking = ref(0);
  const total_earned = ref(0);

  const finished_copy = ref(0);
  const running_copy = ref(0);
  const amount_copy = ref(0);
  const total_copy = ref(0);

  const withdrawModal = ref(false);
  const depositModal = ref(false);

  const profile = ref({});
  const hasBot = ref(false);

  const email = ref("mail");
  const country = ref("BR");
  const link_affiliate = ref("");

  type Licenses = {
    ID: number;
    CreatedAt: string;
    Amount: number;
    Used: number;
  };

  type Stake = {
    ID: number;
    CreatedAt: string;
    Amount: number;
    Used: number;
    Profit: number;
    TimeStake: number;
    FinishReason: null | string;
  };

  type Operations = {
    CreatedAt: string;
    Name: string;
    Payout: number;
    Percentage: number;
  };

  type Primezord = {
    ID: string;
    OperationTimestamp: string;
    Notes: string;
    Percentage: number;
  };

  type InvestmentsBot = {
    CreatedAt: string;
    InvestedAt: string;
    MaturityDate: string;
    Status: string;
    Name: string;
    Payout: number;
    ID: number;
    UserID: number;
  };

  type Users = {
    ID: number;
    CreatedAt: string;
    Email: string;
    ScPhone: string;
  };
  type WalletBot = {
    ID: number;
    Balance: number;
    AvailableForWithdraw: number;
    PendingProfit: number;
  };
  const stakes: Ref<Stake[]> = ref([]);
  const licences: Ref<Licenses[]> = ref([]);
  const investmentsBot: Ref<InvestmentsBot[]> = ref([]);
  const operations: Ref<Operations[]> = ref([]);
  const primezord: Ref<Primezord[]> = ref([]);
  const users: Ref<Users[]> = ref([]);
  const bonus = ref([]);
  const walletBot: Ref<WalletBot | null> = ref(null);
  const withdrawals = ref([]);
  const residual = ref([]);

  const fetchStakes = () => {
    useApiFetch("/api/stakes").then((res) => {
      if (!res.error.value) {
        if (res.data.value) {
          fetchUser();
          fetchHR();
          stakes.value = res.data.value;
        } else {
          stakes.value = [];
        }
      }
    });
  };

  const getLicences = () => {
    useApiFetch("/api/copytrade").then((res) => {
      if (!res.error.value) {
        if (res.data.value) {
          fetchUser();
          fetchHR();
          licences.value = res.data.value;
        } else {
          licences.value = [];
        }
      }
    });
  };

  const fetchUser = async () => {
    await useApiFetch("/api/user").then((res) => {
      if (!res.error.value) {
        if (res.data.value) {
          balance.value = res.data.value.Balance;
          email.value = res.data.value.Email;
          profile.value = res.data.value;
          hasBot.value = res.data.value.Hasbot;
          link_affiliate.value =
            "https://traderoom.primeoptions.io/auth?code=" +
            res.data.value.Code;
          localStorage.setItem("uuid", res.data.value.Uuid);
        }
      } else {
        localStorage.removeItem("token");
        router.push("/auth/login");
      }
    });
  };

  const updatePassword = async (password: string) => {
    try {
      return await useApiFetch("/api/password/" + password, {
        method: "POST",
        body: JSON.stringify({
          password: password,
        }),
      });
    } catch (e) {
      console.log(e);
    }
  };

  const updateData = async (phone: string, birth: string) => {
    try {
      return await useApiFetch(`/api/user/${phone}/${birth}`, {
        method: "PUT",
        body: JSON.stringify({
          phone: phone,
          birth: birth,
        }),
      });
    } catch (e) {
      console.log(e);
    }
  };

  const updateAvatar = async (file: FormData) => {
    try {
      return await useApiFetch("/api/user/avatar", {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        body: file,
        method: "POST",
      });
    } catch (e) {
      console.log(e);
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("accessToken");
    router.push("/auth/login");
  };

  const fetchHR = () => {
    useApiFetch("/api/homereport").then((res) => {
      if (!res.error.value) {
        if (res.data.value) {
          amount_staking.value = res.data.value.Amount;
          finished_stakes.value = res.data.value.Finished;
          running_stakes.value = res.data.value.Running;
          total_earned.value = res.data.value.Profit;
          finished_copy.value = res.data.value.Finishedcopy;
          running_copy.value = res.data.value.Runningcopy;
          amount_copy.value = res.data.value.Amountcopy;
          total_copy.value = res.data.value.Profitcopy;
        }
      }
    });
  };

  const newStake = async (value: number, time: number) => {
    try {
      const res = await useApiFetch("/api/stake", {
        method: "POST",
        body: JSON.stringify({
          amount: value,
          time_stake: time,
        }),
      });

      if (res.error.value) {
        fetchStakes();
        return {
          success: false,
          message: res.error.value.data?.message || "Erro ao criar stake.",
        };
      } else {
        fetchStakes();
        return {
          success: true,
          message: "Stake criada com sucesso!",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: "Erro inesperado ao criar stake.",
      };
    }
  };

  const robotSubscribe = async () => {
    try {
      const res = await useApiFetch("/api/bot/subscribe", {
        method: "POST",
        body: JSON.stringify({}),
      });

      if (res.error.value) {
        return {
          success: false,
          message: res.error.value.data?.message || "Erro ao criar stake.",
        };
      } else {
        return {
          success: true,
          message: "Stake criada com sucesso!",
        };
      }
    } catch (error) {
      console.log(error);
      return {
        success: false,
        message: "Erro inesperado ao criar stake.",
      };
    }
  };

  const depositBot = async (amount: number) => {
    try {
      const res = await useApiFetch("/api/bot/deposit", {
        method: "POST",
        body: JSON.stringify({
          amount: amount,
        }),
      });

      if (res.error.value) {
        return {
          success: false,
          message: res.error.value.data?.message || "Erro ao criar stake.",
        };
      } else {
        return {
          success: true,
          message: "Deposito efetuado com sucesso",
        };
      }
    } catch (error) {
      console.log(error);
      return {
        success: false,
        message: "Erro inesperado ao criar stake.",
      };
    }
  };
  const getInvestmentBots = async () => {
    try {
      const res = await useApiFetch("/api/bot/investments", {
        method: "GET",
      });

      if (res.error.value) {
        return {
          success: false,
          message: res.error.value.data?.message || "Erro ao criar stake.",
        };
      } else {
        investmentsBot.value = res.data.value ?? [];
        return {
          success: true,
          message: "Sucesso",
        };
      }
    } catch (error) {
      console.log(error);
      return {
        success: false,
        message: "Erro inesperado ao criar stake.",
      };
    }
  };
  const getBotSettings = async () => {
    try {
      const res = await useApiFetch("/api/bot/settings", {
        method: "GET",
      });

      if (res.error.value) {
        return {
          success: false,
          message:
            res.error.value.data?.message ||
            "Erro ao buscar valor da assinatura",
        };
      } else {
        return res.data.value.EntryFee;
      }
    } catch (error) {
      console.log(error);
      return {
        success: false,
        message: "Erro inesperado ao buscar valor da assinatura",
      };
    }
  };

  const withdrawBot = async (amount: number) => {
    try {
      const res = await useApiFetch("/api/bot/withdraw", {
        method: "POST",
        body: JSON.stringify({
          amount: amount,
        }),
      });

      if (res.error.value) {
        return {
          success: false,
          message: res.error.value.data?.message || "Erro ao criar stake.",
        };
      } else {
        return {
          success: true,
          message: "Saque efetuado com sucesso",
        };
      }
    } catch (error) {
      console.log(error);
      return {
        success: false,
        message: "Erro inesperado ao criar stake.",
      };
    }
  };

  const investBot = async (amount: number) => {
    try {
      const res = await useApiFetch("/api/bot/invest", {
        method: "POST",
        body: JSON.stringify({
          amount: amount,
        }),
      });

      if (res.error.value) {
        return {
          success: false,
          message: res.error.value.data?.message || "Erro.",
        };
      } else {
        return {
          success: true,
          message: "Investimento aplicado com sucesso",
        };
      }
    } catch (error) {
      console.log(error);
      return {
        success: false,
        message: "Erro inesperado ao criar stake.",
      };
    }
  };

  const getWalletBot = async () => {
    try {
      const res = await useApiFetch("/api/bot/wallet", {
        method: "GET",
        body: JSON.stringify({}),
      });

      if (res.error.value) {
        return {
          success: false,
          message: res.error.value.data?.message || "Erro ao criar stake.",
        };
      } else {
        walletBot.value = res.data.value;
        console.log(walletBot.value);
        return {
          success: true,
          message: res.data.value,
        };
      }
    } catch (error) {
      return {
        success: false,
        message: "Erro inesperado ao criar stake.",
      };
    }
  };
  const cancelStake = async (id: number) => {
    try {
      const res = await useApiFetch("/api/stake/" + id, {
        method: "POST",
      });

      if (res.error.value) {
        fetchStakes();
        return {
          success: false,
          message: res.error.value.data?.message || "Erro ao cancelar stake.",
        };
      } else {
        fetchStakes();
        return {
          success: true,
          message: "Stake cancelada com sucesso!",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: "Erro inesperado ao cancelar stake.",
      };
    }
  };

  const newCopy = (value: number) => {
    useApiFetch("/api/copytrade", {
      method: "POST",
      body: JSON.stringify({
        amount: value,
      }),
    }).then((res) => {
      if (res.error.value) {
        getLicences();
      } else {
        getLicences();
      }
    });
  };

  const deposit = async (value: number, currency: string) => {
    try {
      const res = await useApiFetch("/api/deposit", {
        method: "POST",
        body: JSON.stringify({
          amount: value,
          user: localStorage.getItem("uuid"),
          currency: currency,
        }),
      });

      if (!res.error.value) {
        fetchStakes();
        return {
          success: true,
          message: "Depósito realizado com sucesso!",
        };
      } else {
        return {
          success: false,
          message:
            res.error.value.data?.message || "Erro ao realizar depósito.",
        };
      }
    } catch (e) {
      return {
        success: false,
        message: "Erro inesperado ao processar o depósito.",
      };
    }
  };

  const withdraw = async (value: number, currency: string) => {
    try {
      const res = await useApiFetch("/api/withdraw", {
        method: "POST",
        body: JSON.stringify({
          amount: value,
          user: localStorage.getItem("uuid"),
          currency: currency,
        }),
      });

      if (!res.error.value) {
        fetchStakes();
        return {
          success: true,
          message: "Saque realizado com sucesso!",
        };
      } else {
        return {
          success: false,
          message: res.error.value.data?.message || "Erro ao solicitar saque.",
        };
      }
    } catch (e) {
      return {
        success: false,
        message: "Erro inesperado ao processar o saque.",
      };
    }
  };

  const getNetwork = () => {
    useApiFetch("/api/sponsors").then((res) => {
      if (!res.error.value) {
        users.value = res.data.value || [];
        return res.data.value || [];
      } else {
        console.error("Erro ao buscar rede:", res.error.value);
        return [];
      }
    });
  };

  const getSubNetwork = async (id: number) => {
    const res = await useApiFetch(`/api/sponsors/${id}`);

    if (!res.error?.value) {
      return res.data.value || [];
    } else {
      console.error("Erro ao buscar rede:", res.error.value);
      return [];
    }
  };

  const getTaxDolar = async (isLow: boolean): Promise<number> => {
    try {
      const res = await axios.get(
        "https://economia.awesomeapi.com.br/json/last/USD-BRL",
      );
      return isLow
        ? parseFloat(res.data?.USDBRL?.low || 0)
        : parseFloat(res.data?.USDBRL?.high || 0);
    } catch (error) {
      console.error("Erro ao buscar cotação do dólar:", error);
      return 0;
    }
  };

  const getReport = () => {
    useApiFetch("/api/report").then((res) => {
      if (!res.error.value) {
        return res.data.value || [];
      } else {
        console.error("Erro ao buscar rede:", res.error.value);
        return [];
      }
    });
  };

  const getReportTipo = async (tipo: number) => {
    useApiFetch(`/report/${tipo}`).then((res) => {
      if (!res.error.value) {
        if (tipo === 5) {
          withdrawals.value = res.data.value;
        }
        if (tipo === 2) {
          bonus.value = res.data.value;
        }
        if (tipo === 4) {
          residual.value = res.data.value;
        }
        return res.data.value || [];
      } else {
        console.error("Erro ao buscar rede:", res.error.value);
        return [];
      }
    });
  };

  const getOperations = () => {
    useApiFetch("/api/copytrade/report").then((res) => {
      if (!res.error.value) {
        operations.value = res.data.value || [];
        return res.data.value || [];
      } else {
        console.error("Erro ao buscar operações:", res.error.value);
        return [];
      }
    });
  };

  const getPrimezordOperation = () => {
    useApiFetch("/api/bot/reports/operations").then((res) => {
      if (!res.error.value) {
        primezord.value = res.data.value || [];
        return res.data.value || [];
      } else {
        console.error("Erro ao buscar operações:", res.error.value);
        return [];
      }
    });
  };

  return {
    showBotModal,
    showDepositModal,
    hideBotModal,
    hideDepositModal,
    balance,
    finished_stakes,
    running_stakes,
    amount_staking,
    total_earned,
    withdrawModal,
    depositModal,
    profile,
    email,
    country,
    link_affiliate,
    stakes,
    operations,
    fetchStakes,
    newStake,
    fetchHR,
    deposit,
    withdraw,
    users,
    getNetwork,
    getSubNetwork,
    fetchUser,
    getLicences,
    licences,
    showCopyModal,
    hideCopyModal,
    logout,
    withdrawals,
    residual,
    bonus,
    newCopy,
    finished_copy,
    running_copy,
    amount_copy,
    hideWithdrawModal,
    robotSubscribe,
    total_copy,
    hidePrimezordModal,
    getReport,
    cancelStake,
    walletBot,
    depositBot,
    withdrawBot,
    investBot,
    getWalletBot,
    getReportTipo,
    hasBot,
    getInvestmentBots,
    investmentsBot,
    getOperations,
    primezord,
    total_commissions,
    getPrimezordOperation,
    getTaxDolar,
    updatePassword,
    updateData,
    updateAvatar,
    getBotSettings,
  };
});
